var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { AugLoopTextDecoder, AugLoopTextEncoder } from './augloop-text-encoding';
/**
 * To get quick view how JSOND format of the message looks like go to modules\jsond-stream\src\jsond-stream.ts
 */
var JSOND = /** @class */ (function () {
    function JSOND() {
    }
    JSOND.deserialize = function (data, binaryFieldConverter) {
        if (binaryFieldConverter === void 0) { binaryFieldConverter = function (data) { return data; }; }
        if (data[0] !== JSOND.IDENTIFIERBYTE) {
            throw "Invalid Binary: Incorrect Identifier";
        }
        var offset = 1;
        var fragments = [];
        var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
        while (offset < data.byteLength) {
            if (offset + 4 > data.byteLength) {
                throw "Invalid Binary: Error reading fragment length";
            }
            var fragmentLength = view.getUint32(offset);
            if (offset + fragmentLength + 4 > data.byteLength) {
                throw "Invalid Binary: Fragment out of range";
            }
            if (typeof Buffer !== 'undefined' && Buffer.from) {
                fragments.push(Buffer.from(data.buffer, data.byteOffset + offset + 4, fragmentLength));
            }
            else {
                fragments.push(new Uint8Array(data.buffer, data.byteOffset + offset + 4, fragmentLength));
            }
            offset += 4 + fragmentLength;
        }
        if (fragments.length < 1) {
            throw "Invalid Binary: No fragments found";
        }
        var jsonText = JSOND.textDecoder.decode(fragments[0]);
        var reviver = function (_key, value) {
            if ('string' === typeof value) {
                if (value.substring(0, JSOND.BINARYKEYWORD.length) === JSOND.BINARYKEYWORD) {
                    var index = parseInt(value.substring(JSOND.BINARYKEYWORD.length), 10);
                    if (typeof index !== 'number' || index >= fragments.length - 1) {
                        throw "Invalid Binary: Binary index out of range";
                    }
                    return binaryFieldConverter(fragments[index + 1]);
                }
                else if (value.substring(0, JSOND.ESCAPEKEYWORD.length) === JSOND.ESCAPEKEYWORD) {
                    return value.substring(JSOND.ESCAPEKEYWORD.length);
                }
            }
            return value;
        };
        return JSON.parse(jsonText, reviver);
    };
    JSOND.serialize = function (obj) {
        var e_1, _a;
        var fragments = [undefined];
        var replacer = function (_key, value) {
            if (ArrayBuffer.isView(value)) {
                fragments.push(value);
                return "".concat(JSOND.BINARYKEYWORD).concat(fragments.length - 2);
            }
            else if (value && value.type === 'Buffer' && Array.isArray(value.data)) {
                fragments.push(new Uint8Array(value.data));
                return "".concat(JSOND.BINARYKEYWORD).concat(fragments.length - 2);
            }
            else if ('string' === typeof value && (value.substring(0, JSOND.ESCAPEKEYWORD.length) === JSOND.ESCAPEKEYWORD)) {
                return JSOND.ESCAPEKEYWORD + value;
            }
            return value;
        };
        var json = JSON.stringify(obj, replacer);
        fragments[0] = JSOND.textEncoder.encode(json);
        var aggregateLength = fragments.reduce(function (accumulator, buffer) { return accumulator + 4 + buffer.byteLength; }, 0);
        var retVal = new Uint8Array(aggregateLength + 1);
        retVal[0] = JSOND.IDENTIFIERBYTE;
        var offset = 1;
        var view = new DataView(retVal.buffer, retVal.byteOffset, retVal.byteLength);
        try {
            for (var fragments_1 = __values(fragments), fragments_1_1 = fragments_1.next(); !fragments_1_1.done; fragments_1_1 = fragments_1.next()) {
                var buffer = fragments_1_1.value;
                view.setUint32(offset, buffer.byteLength);
                retVal.set(buffer, offset + 4);
                offset += 4 + buffer.byteLength;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (fragments_1_1 && !fragments_1_1.done && (_a = fragments_1.return)) _a.call(fragments_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return retVal;
    };
    JSOND.IDENTIFIERBYTE = 0x03;
    JSOND.BINARYKEYWORD = ':b';
    JSOND.ESCAPEKEYWORD = ':';
    JSOND.textDecoder = new AugLoopTextDecoder();
    JSOND.textEncoder = new AugLoopTextEncoder();
    return JSOND;
}());
export { JSOND };
//# sourceMappingURL=jsond.js.map